import React from 'react'
import { useDispatch } from 'react-redux'
import Carousel from 'react-native-snap-carousel'
import PropTypes from 'prop-types'
import { Dimensions } from 'react-native'
import LoadCard from '../LoadCard'
import styles from './styles'
import { getTractorDetails } from '../../../../redux/loadDetails/loadDetailsActions'
import { usePlatforms } from '../../../../hooks/usePlatforms'

const { width } = Dimensions.get('window')

const LoadsCarousel = ({ details, module, currentLoad, setCurrentLoad }) => {
  const { isTablet } = usePlatforms()
  const dispatch = useDispatch()

  const onChangeLoad = (index) => {
    const newCurrentLoad = details.loads[index]
    if (module === 'assigned-order') dispatch(getTractorDetails(newCurrentLoad.movementNumber))
    setCurrentLoad({
      load: newCurrentLoad,
      index
    })
  }

  return currentLoad && currentLoad.load && currentLoad.load.movementNumber ? (
    <Carousel
      data={details.loads}
      firstItem={currentLoad.index}
      renderItem={({ item }) => (
        <LoadCard
          load={item}
          selected={item.movementNumber === currentLoad.load.movementNumber}
          module={module}
        />
      )}
      sliderWidth={width}
      itemWidth={width * 0.85}
      onBeforeSnapToItem={onChangeLoad}
      scrollEnabled={!isTablet}
      lockScrollWhileSnapping
      initialScrollIndex={currentLoad.index}
      getItemLayout={(_, index) => ({
        length: width * 0.85,
        offset: (width * 0.85) * index,
        index
      })}
      initialNumToRender={1}
      maxToRenderPerBatch={1}
      slideStyle={styles.itemElevation}
    />
  ) : null
}

LoadsCarousel.propTypes = {
  details: PropTypes.object,
  module: PropTypes.string,
  currentLoad: PropTypes.object,
  setCurrentLoad: PropTypes.func
}

export default LoadsCarousel
